import React, { Component } from 'react'
import Popover from 'react-popover'
import { observer } from 'mobx-react'

//FIXME:Need to add prop type to PopoverContentProps
interface PopoverContentProps {
   popoverProps: any
   children: any //TODO:Handle type properly
}

const PopoverContent = observer(
   class PopoverContent extends Component<PopoverContentProps> {
      render() {
         const { children, popoverProps } = this.props

         return <Popover {...popoverProps}>{children}</Popover>
      }
   }
)

export { PopoverContent }
